export default __webpack_public_path__ + "static/media/slider-3.74fb9bc9.jpg";